import React from 'react';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import { pageTitle } from '../../helpers/PageTitle';
import Section from '../Section';
import PricingSection from '../Section/PricingSection';
import FaqSectionStyle4 from '../Section/FaqSection/FaqSectionStyle4';
import { useEffect } from 'react';
import { getServices } from '../../helpers/lib/axios';

const pricingData = [
  {
    title: 'Individual Therapy',
    featureList: [
      'Personalized one-on-one sessions with a therapist, available in person at our office or online to suit your preference. Book a consult call today to get started.',
    ],
    btnText: 'Learn More',
    btnUrl: '/appointments',
    popular: false,
  },
 {
    title: 'Group Therapy',
    subTitle:
      'Physical Session',
    featureList: [
      'Supportive therapy sessions for couples, families, or individuals who benefit from shared experiences and guided discussions. Schedule a consult call to find the right group for you.',
    ],
    btnText: 'Learn More',
    btnUrl: '/appointments',
    popular: false,
  },
  {
    title: 'Organizational Workshops',

    featureList: [
      'Training and consultancy for schools, universities, and corporate teams, designed to foster mental well-being, resilience, and productivity. Contact us to book a consult call for your organization',
    ],
    btnText: 'Learn More',
    btnUrl: '/appointments',
    popular: false,
  },
];

const faqData = [
  {
    title: 'Do you only work with individuals, or do you also collaborate with organizations?',
    content:
      'We work with both individuals and organizations. Individuals can access therapy, while organizations can partner with us for tailored mental health trainings, workshops, and seminars.',
  },
  {
    title: '⁠Do you work with children, teens, or only adults?',
    content:
      'We work with teenagers and young adult individuals. Please contact us to determine which services suit your needs.',
  },
  {
    title: 'Do you offer online therapy sessions?',
    content:
      'Yes, we offer both in-person and online therapy options to cater to your convenience.',
  },
  {
    title: 'How do I book a therapy session, a workshop or training session for my organization?',
    content:
      'You can book an appointment by calling us, emailing, or using the booking form on our website.',
  },
  {
    title: 'Can workshops be customized for specific needs?',
    content:
      'Absolutely! We tailor workshops and trainings to meet the specific needs of your organization or group.',
  },
];
export default function PricingPlan() {
  const [services, setServices] = React.useState([]);
  useEffect(() => {

      getServices().then(user => {
        console.log(user)
        setServices(user?.data);
      }).catch(err => console.log(err))

  }, [])

  const groupedServices = services.reduce((result, service) => {
    const { type, location } = service;

    // Initialize the group for the type if it doesn't exist
    if (!result[type]) {
      result[type] = { PHYSICAL: [], ONLINE: [] };
    }

    // Add the service to the appropriate location group
    result[type][location].push(service);

    return result;
  }, {});

  // Now you can access cards for each type and location
  Object.keys(groupedServices).forEach(type => {
    const physicalServices = groupedServices[type].PHYSICAL;
    const onlineServices = groupedServices[type].ONLINE;

    console.log(`Type: ${type}`);
    console.log('PHYSICAL Services:', physicalServices);
    console.log('ONLINE Services:', onlineServices);

    // You can create cards here
  });

  pageTitle('Pricing Plan');
  return (
    <div className='pb-[0px]'>
      <BannerSectionStyle3
        bgUrl="/images/pricing_plan/banner_bg.svg"
        imgUrl="/images/new/Mental health icon 24 Calm mind.png"
        title="We have a plan that <br /> works for you"
        subTitle="Explore Our Pricing Options and Start Your Journey to Better Health"
        btnText="Get Starter"
        btnUrl="/contact"
      />
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <PricingSection
          sectionTitle="Choose From any of our <br />Rate Cards"
          data={pricingData}
        />
      </Section>
      <Section
        topMd={185}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
        className="cs_gray_bg_1"
      >
        <FaqSectionStyle4
          sectionTitle="Frequently Asked <br />Questions"
          data={faqData}
          faqImgUrl="/images/new/Mental health icon 21 Psychology talk.png"
        />
      </Section>
      <Section
        topMd={200}
        topLg={150}
        topXl={110}
        className="cs_footer_margin_0"
      >
      </Section>
    </div>
  );
}
